import template from './countries.html';
import './countries.scss';

let countriesComponent = {
  bindings: {
    countries: '<',
    selected: '<',
    disabled: '<',
    onSelect: '&'
  },
  template
};

export default countriesComponent;



// WEBPACK FOOTER //
// ./src/app/components/countries/countries.component.js